import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class AsideTitle extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string,
        children: PropTypes.object,
    };

    render() {
        const { title, children } = this.props;

        return (
            <div className={styles.title}>
                {children}
                <h4>{title}</h4>
            </div>
        );
    }
}

export default errorBoundary(AsideTitle);
